import React from 'react';
import PropTypes from 'prop-types';
const cdnDomain = 'https://assets.peerspace.com'
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const SubTextOrError = ({ subText, errorMessage = null, divider, dividerColor }) => {
  const dividerStyles = {
    backgroundColor: dividerColor
  };

  return (
    <div>
      { errorMessage
        ? <p className="text-danger text-center subform-text">{errorMessage}</p>
        :
        <div>
          <p className="text-center subform-text">{subText}</p>
          {
            divider ?
              <p className="divider-word">
                <span className="subform-text" style={dividerStyles}>
                  <FormattedMessage id="shared_components.cleaning_types.divider_text" defaultMessage="or" />
                </span>
              </p>
              : ''
          }
        </div>
      }
    </div>
  );
};

SubTextOrError.propTypes = {
  divider: PropTypes.bool,
  dividerColor: PropTypes.string,
  subText: PropTypes.string,
  errorMessage: PropTypes.string
};

export const SocialLoginButton = ({
  divider,
  dividerColor = '#fff',
  clickFn,
  buttonText,
  subText,
  errorMessage = '',
  buttonClass,
  imageAlt,
  imageSrc,
  buttonID,
  isLoading,
  hideButton = false
}) => {
  return (
    <div className={ classNames('social-login-wrapper', { hidden: hideButton }) }>
      <button id={buttonID} className={`btn btn-block ${buttonClass} ${isLoading ? 'disabled' : ''}`} disabled={isLoading} onClick={clickFn}>
        <div className="flex middle center">
          <img alt={imageAlt} width="24" src={`${cdnDomain}/${imageSrc}`} className={ isLoading ? 'loading' : '' } />
          <div className="btn-text margin-md-left">
            {
              buttonText
            }
          </div>
        </div>
      </button>
      <SubTextOrError errorMessage={errorMessage} subText={subText} divider={divider} dividerColor={dividerColor} />
    </div>
  );
};

SocialLoginButton.propTypes = {
  divider: PropTypes.bool,
  dividerColor: PropTypes.string,
  clickFn: PropTypes.func,
  buttonText: PropTypes.element,
  subText: PropTypes.string,
  errorMessage: PropTypes.element,
  buttonClass: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  buttonID: PropTypes.string,
  isLoading: PropTypes.bool,
  hideButton: PropTypes.bool
};
